import React from 'react';
import { EmployerLayout } from '../../JobPostPricing/EmployerLayout';
import Pagination from '../../MyJobs/Pagination';
import EmployerList from './CandidateList';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/Components/ui/button';
import { ChevronLeft, User } from 'lucide-react';

export const EmployerPage = () => {
  const navigate = useNavigate();
  return (
    <EmployerLayout>
      <div className="flex flex-col w-full gap-6">
        <div className="flex items-center justify-end">
          <Button 
            variant="outline"
            className="text-slate-900 font-semibold text-base py-2.5 px-3 border-2 border-blue-400 rounded-lg flex items-center gap-2 bg-slate-100"
            onClick={() => navigate('/hirewithus/postjob')}
          >
            <ChevronLeft className="w-5 h-5" />
            Post Job
            <User className="w-5 h-5" />
          </Button>
        </div>
        <div className="flex flex-1 flex-col gap-8">
          <EmployerList />
        </div>
      </div>
    </EmployerLayout>
  );
};